import type { AdaptiveFlashcardModality } from '@core/models/adaptive-flashcard-modality.enum';

export enum TrainCardType {
  Text = 1,
  Image = 2,
  VideoOnly = 3,
  AudioRecord = 4,
  ShortTalk = 5,
  AudioConversation = 6,
  Pronunciation = 7,
}

export enum TrainCardSubType {
  TextSimple = 1,
  TextTypedOrVoice = 2,
  TextSingleChoice = 3,
  TextMultipleChoice = 4,
}

export type TrainMode = 'due' | 'all';

export type TrainOption = {
  id: number;
  text: string;
  isCorrect: boolean;
};

export type TrainAsset = {
  id: number;
  type: number;
  scope?: number;
  origin?: number;
  targetId?: number | null;
  jobId?: number | null;
  fileName: string;
  mimeType: string;
  url: string;
  altText?: string;
};

export type TrainFlashcard = {
  id: number;
  reviewFlashcardId: number;
  adaptiveModality?: AdaptiveFlashcardModality;
  frontText: string;
  backText: string;
  explanation: string;
  shortTalkScenario: string;
  shortTalkLearnerGoal: string;
  shortTalkSuccessCriteria: string;
  shortTalkMaxTurns: number;
  cardType: number;
  cardSubType: number;
  languageCodeProvider: string;
  aiTtsVoiceId?: number | null;
  enableAiEvaluation?: boolean;
  dueAt: string;
  progress: number;
  options: TrainOption[];
  assets: TrainAsset[];
};
